import BaseService from './Base';

class Sectors extends BaseService {
  static endpoint = 'api/2.0/sectors/';
}

export default Sectors;